/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioVolumeS2Icon16Light } from './MediaAudioVolumeS2Icon16Light';
import { MediaAudioVolumeS2Icon16Regular } from './MediaAudioVolumeS2Icon16Regular';
import { MediaAudioVolumeS2Icon16Solid } from './MediaAudioVolumeS2Icon16Solid';
import { MediaAudioVolumeS2Icon20Light } from './MediaAudioVolumeS2Icon20Light';
import { MediaAudioVolumeS2Icon20Regular } from './MediaAudioVolumeS2Icon20Regular';
import { MediaAudioVolumeS2Icon20Solid } from './MediaAudioVolumeS2Icon20Solid';
import { MediaAudioVolumeS2Icon24Regular } from './MediaAudioVolumeS2Icon24Regular';
import { MediaAudioVolumeS2Icon24Solid } from './MediaAudioVolumeS2Icon24Solid';
import { MediaAudioVolumeS2Icon32Regular } from './MediaAudioVolumeS2Icon32Regular';
import { MediaAudioVolumeS2Icon64Regular } from './MediaAudioVolumeS2Icon64Regular';
var sizes = {
    16: {
        light: MediaAudioVolumeS2Icon16Light,
        regular: MediaAudioVolumeS2Icon16Regular,
        solid: MediaAudioVolumeS2Icon16Solid,
    },
    20: {
        light: MediaAudioVolumeS2Icon20Light,
        regular: MediaAudioVolumeS2Icon20Regular,
        solid: MediaAudioVolumeS2Icon20Solid,
    },
    24: {
        regular: MediaAudioVolumeS2Icon24Regular,
        solid: MediaAudioVolumeS2Icon24Solid,
    },
    32: {
        regular: MediaAudioVolumeS2Icon32Regular,
    },
    64: {
        regular: MediaAudioVolumeS2Icon64Regular,
    },
};
export var MediaAudioVolumeS2Icon = forwardRef('MediaAudioVolumeS2Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
